__turbopack_context__.v({
  "green": "V953eW_green",
  "lg": "V953eW_lg",
  "link": "V953eW_link",
  "md": "V953eW_md",
  "root": "V953eW_root",
  "sm": "V953eW_sm",
});
